import { eulaUpdateStatus } from '../../../../app/types';
import type { ManEulaStatus } from '../../../../services/schemas/accountsBackendCodec';
import { EulaStatusDialog, type EulaStatusDialogConfig } from './EulaStatusDialog';

interface RevokeEulaDialogProps {
    eulaStatus: ManEulaStatus;
}

const revokeEulaDialogConfig: EulaStatusDialogConfig = {
    buttonText: 'Revoke EULA',
    confirmationText: 'REVOKE',
    confirmButtonText: 'Revoke',
    dialogTitle: 'Revoke EULA',
    errorLogVerb: 'revoke',
    errorMessageId: 'helpgang.notification.couldNotRevokeEula',
    isButtonDisabled: status => status !== 'ACCEPTED',
    successMessageId: 'helpgang.notification.revokeEulaSuccess',
    targetStatus: eulaUpdateStatus.REVOKED,
};

export const RevokeEulaDialog = ({ eulaStatus }: RevokeEulaDialogProps) => (
    <EulaStatusDialog config={revokeEulaDialogConfig} eulaStatus={eulaStatus} />
);
